import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import Billing from "@/pages/Billing";
import Monitoring from "@/pages/Monitoring";
import FloatingCTAs from "@/components/FloatingCTAs";
import ScrollToTop from "@/components/ScrollToTop";
import VisitTracker from "@/components/VisitTracker";

function App() {
  return (
    <div className="App font-sans">
      <BrowserRouter>
        <ScrollToTop />
        <VisitTracker />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/billing" element={<Billing />} />
          <Route path="/monitoring" element={<Monitoring />} />
          <Route path="*" element={<Home />} />
        </Routes>
        <AdminAwareCTAs />
      </BrowserRouter>
      <Toaster theme="dark" position="top-center" richColors />
    </div>
  );
}

function AdminAwareCTAs() {
  const path = window.location.pathname;
  if (path.startsWith("/admin") || path.startsWith("/monitoring")) return null;
  return <FloatingCTAs />;
}

export default App;
